import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { useStyles } from './prefill_styles';

// reverted the code for this file to later refactor has updated props and prevet prefill.
const hasUpdatedCarProps = (carMake, carModel, carRedbookCode, state) => {
    if ([carMake, carModel, carRedbookCode].some((prop) => !prop)) {
        return false;
    }
    const previousMake = state.getIn(['vertical', 'quote', 'prefillVerify', 'response', 'data', 'form', 'coverDetail', 'vehicle', 'make']);
    const previousModel = state.getIn(['vertical', 'quote', 'prefillVerify', 'response', 'data', 'form', 'coverDetail', 'vehicle', 'model']);
    const previousCarRedbookCode = state.getIn(['vertical', 'quote', 'prefillVerify', 'response', 'data', 'form', 'coverDetail', 'vehicle', 'redbookCode']);
    // Check if any of the car properties have changed
    return (
        carMake !== previousMake
        || carModel !== previousModel
        || carRedbookCode !== previousCarRedbookCode
    );
};

const _PrefillVerifyTrigger = (props) => {
    const {
        carMake,
        carModel,
        carRedbookCode,
        dispatch,
        isVerifying,
        preventCarRedbookCode,
        hasNewCarProps,
        isEditingDetails
    } = props;
    const alreadyCalledRef = useRef(false);
    const classes = useStyles();
    const nextPageName = 'car_colour';
    const preventPrefill = carRedbookCode === preventCarRedbookCode;

    // Trigger prefill verify when carRedbookCode is available.
    useEffect(() => {
        if (carRedbookCode && !alreadyCalledRef.current && !isVerifying && hasNewCarProps && !isEditingDetails) {
            alreadyCalledRef.current = true;

            // Dispatch saga action with required payload
            dispatch({
                type: 'DO_PREFILL_VERIFY',
                payload: {
                    requestPayload: {
                        carRedbookCode
                    },
                    nextPageName,
                    preventPrefill
                }
            });
        }
    }, [carMake, carModel, carRedbookCode, dispatch, nextPageName, isEditingDetails]);

    return (
        <div className={classes.carPrefillWrapper}>
            {isVerifying
                ? (
                    <div className={classes.fullscreenLoaderWrapper}>
                        <div style={{
                            margin: '0 auto',
                            width: '72px',
                            height: '72px',
                            borderRadius: '50%',
                            border: '8.5px solid #0B60B7',
                            borderBottomColor: 'transparent',
                            animation: 'spin 1s linear infinite'
                        }}>
                            <style>
                                {
                                    `@keyframes spin {
                                    to {
                                        transform: rotate(360deg);
                                    }
                                }`
                                }
                            </style>
                        </div>
                    </div>
                )
                : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    const env = state.getIn(['serverConfig', 'env']);
    const carMake = state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle', 'make']);
    const carModel = state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle', 'model']);
    const carRedbookCode = state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle', 'redbookCode']);
    const isVerifying = state.getIn(['vertical', 'quote', 'prefillVerify', 'isVerifying']);
    const preventCarRedbookCode = quoteFormSelector(state).getIn(['helpers', 'preventPrefill', 'redbookCode']);
    const hasNewCarProps = hasUpdatedCarProps(carMake, carModel, carRedbookCode, state);
    const isEditingDetails = state.getIn(['vertical', 'quote', 'form', 'helpers', 'prefill', 'isEditingDetails']);
    return { env, carMake, carModel,  carRedbookCode, isVerifying, preventCarRedbookCode, hasNewCarProps, isEditingDetails };
};

const PrefillVerifyTrigger = connect(
    mapStateToProps
)(_PrefillVerifyTrigger);

_PrefillVerifyTrigger.propTypes = {
    carMake: PropTypes.string,
    carModel: PropTypes.string,
    carRedbookCode: PropTypes.string,
    isVerifying: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    isEditingDetails: PropTypes.bool
};

export { _PrefillVerifyTrigger, PrefillVerifyTrigger };
